import axios from "axios";
import Config from "../../config/config";
import NavigationService from "./navigation.service";
import { getSession } from "../../hooks/useSession";

const OshimedAPI = axios.create({
  baseURL: Config.API_URL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
});

const OshimedBackend = axios.create({
  baseURL: Config.BACKEND_URL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Gère les erreurs de requêtes HTTP.
 * - Si le serveur répond, on renvoie la réponse d’erreur du backend ({ success: false, ... }).
 * - Si le serveur est injoignable, on renvoie { success: false, message: 'Network error' }.
 */
export function handleError(error, errorKey) {
  errorKey = errorKey || "0x000000";
  if (error.response) {
    return {
      success: false,
      message: "API error",
      fromError: !Config.IN_PROD
        ? error.response?.data || "Unknown error"
        : null,
      errorKey,
    };
  }
  // Erreur réseau ou serveur injoignable
  return { success: false, message: "Network error", errorKey: 430541 };
}

// ------------------------------
// Intercepteur de requête
// ------------------------------

OshimedAPI.interceptors.request.use(
  (config) => {
    const session = getSession();
    if (session && session.apiToken) {
      config.headers.Authorization = `Bearer ${session.apiToken}`;
    }
    return config;
  },
  (error) => handleError(error, "0x000002")
);

OshimedBackend.interceptors.request.use(
  (config) => {
    const session = getSession();
    if (session && session.platformToken) {
      config.headers.Authorization = `Bearer ${session.platformToken}`;
    }
    return config;
  },
  (error) => handleError(error, "0x000002")
);

// ------------------------------
// Intercepteur de réponse
// ------------------------------

/**
 * Pour gérer plusieurs requêtes concurrentes pendant le rafraîchissement,
 * on met en file d'attente celles qui attendent le nouveau token.
 */

OshimedAPI.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.log("=== error === index.service.js === key: 917745 ===");
    console.dir(error.response?.data || error.response || error, {
      depth: null,
      colors: true,
    });
    console.log("=================================");

    /** ------------------ cmt 290383 ------------------
    if (error.response?.data?.errorCode === "jwt-expired") {
      const originalRequest = error.config;

      //TODO Quand on aurait le controller faudrait l implementé ici
      NavigationService.navigateTo("/");


      const session = getSession();
      if (!session || !session.platformToken) {
        NavigationService.navigateTo("/");
        return;
      }

      originalRequest.headers.Authorization = `Bearer ${session.accessToken}`;
      return OshimedAPI(originalRequest);
    }
    *-------------------------------------------------*/
    return error.response;
  }
);

OshimedBackend.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.log("=== error === index.service.js === key: 764974 ===");
    console.dir(error.response?.data || error.response || error, {
      depth: null,
      colors: true,
    });
    console.log("=================================");

    if (error.response?.data?.errorCode === "jwt-expired") {
      const originalRequest = error.config;

      //TODO Quand on aurait le controller faudrait l implementé ici
      NavigationService.navigateTo("/");
      /* await AuthController.refreshTokens(); */

      const session = getSession();
      if (!session || !session.accessToken) {
        NavigationService.navigateTo("/");
        return;
      }
      /** ------------------ cmt 347921 ------------------
      gestion de l'erreur
      *-------------------------------------------------*/

      originalRequest.headers.Authorization = `Bearer ${session.accessToken}`;
      return OshimedAPI(originalRequest);
    }
    return error.response;
  }
);

export default { OshimedAPI, OshimedBackend };
